module.exports = __webpack_public_path__ + "img/vertex_logo.9231bb13.png";